<div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title mb-0" id="myModalLabel">Add Configurations</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body">
        <ul class="nav nav-pills justify-content-between mb-4 custom-nav mt-2" id="pills-tab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="card-tab" data-toggle="pill" href="#card" role="tab" aria-controls="card"
              aria-selected="true">Card Config</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="fonepay-tab" data-toggle="pill" href="#fonepay" role="tab" aria-controls="fonepay"
              aria-selected="false">Fonepay Config</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="nepalpay-tab" data-toggle="pill" href="#nepalpay" role="tab"
              aria-controls="nepalpay" aria-selected="false">Nepalpay Config</a>
          </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
          <div class="tab-pane fade show active" id="card" role="tabpanel" aria-labelledby="card-tab">
            <form [formGroup]="cardTerminalAddForm">
              <div class="form-group">
                <label for="card-terminal-id">Terminal ID<span style="color: red;">*</span></label>
                <input type="text" class="form-control" formControlName="terminalId" id="card-terminal-id" minlength="8" maxlength="8">
                <small *ngIf="card.terminalId?.errors && submitted" style="color:red">
                  TerminalId is required
                </small>
              </div>
              <div class="form-group">
                <label for="card-merchant-id">Merchant ID<span style="color: red;">*</span></label>
                <input type="text" class="form-control" formControlName="merchantId" id="card-merchant-id" minlength="15" maxlength="15">
                <small *ngIf="card.merchantId?.errors && submitted" style="color: red;">
                  MerchantId is required
                </small>
              </div>
              <div class="form-group">
                <label for="card-currency">Currency<span style="color: red;">*</span></label>
                <ng-select [items]="currency" bindLabel="text" bindValue="text" formControlName="currency"
                  placeholder="Select Currency">
                </ng-select>
                <small *ngIf="card.currency?.errors && submitted" style="color: red;">
                  Currency is required
                </small>
              </div>
              <div class="form-group flex align-items-center d-flex justify-content-between">
                <label for="cash-advance" class="mb-0 mr-4">Manual</label>
                <label class="custom-toggle">
                  <input type="checkbox" formControlName="manualTransaction">
                  <span class="custom-toggle-slider rounded-circle" data-label-off="False" data-label-on="True"></span>
                </label>
              </div>
              <div class="form-group flex align-items-center d-flex justify-content-between">
                <label for="cash-advance" class="mb-0 mr-4">Pre-auth</label>
                <label class="custom-toggle">
                  <input type="checkbox" formControlName="preAuthorization">
                  <span class="custom-toggle-slider rounded-circle" data-label-off="False" data-label-on="True"></span>
                </label>
              </div>
              <div class="form-group flex align-items-center d-flex justify-content-between">
                <label for="cash-advance" class="mb-0 mr-4">TIP</label>
                <label class="custom-toggle">
                  <input type="checkbox" formControlName="tipAdjustment">
                  <span class="custom-toggle-slider rounded-circle" data-label-off="False" data-label-on="True"></span>
                </label>
              </div>
              <div class="form-group flex align-items-center d-flex justify-content-between">
                <label for="cash-advance" class="mb-0 mr-4">Cash Advance POS</label>
                <label class="custom-toggle">
                  <input type="checkbox" formControlName="cashAdvance">
                  <span class="custom-toggle-slider rounded-circle" data-label-off="False" data-label-on="True"></span>
                </label>
              </div>
              <div class="form-group text-right">
                <button type="submit" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="submit" class="btn btn-primary" (click)="onSubmitTerminalAddForm()">Save changes</button>
              </div>
            </form>
          </div>
          <div class="tab-pane fade" id="fonepay" role="tabpanel" aria-labelledby="fonepay-tab">
            <form [formGroup]="fonePayTerminalAddForm" (ngSubmit)="onSubmitTerminalAddForm()">
              <div class="form-group">
                <label for="fonepay-terminal-id">Terminal ID<span style="color: red;">*</span></label>
                <input type="text" class="form-control" formControlName="terminalId" id="fonepay-terminal-id">
                <small *ngIf="fonePay.terminalId?.errors && submitted" style="color: red;">
                  TerminalId is required
                </small>
              </div>
              <div class="form-group">
                <label for="fonepay-merchant-id">Merchant ID<span style="color: red;">*</span></label>
                <input type="text" class="form-control" formControlName="merchantId" id="fonepay-merchant-id">
                <small *ngIf="fonePay.merchantId?.errors && submitted" style="color: red;">
                  Merchant ID is required
                </small>
              </div>
              <div class="form-group">
                <label for="fonepay-currency">Currency<span style="color: red;">*</span></label>
                <input type="text" class="form-control" formControlName="currency" id="fonepay-currency">
                <small *ngIf="fonePay.currency?.errors && submitted" style="color: red;">
                  Currency is required
                </small>
              </div>
              <div class="form-group">
                <label for="fonepay-currency">Merchant Code<span style="color: red;">*</span></label>
                <input type="text" class="form-control" formControlName="merchantCode" id="fonepay-code">
                <small *ngIf="fonePay.merchantCode?.errors && submitted" style="color: red;">
                  Merchant Code is required
                </small>
              </div>
              <div class="form-group">
                <label for="fonepay-currency">Merchant Category Code<span style="color: red;">*</span></label>
                <input type="text" class="form-control" formControlName="merchantCategoryCode"
                  id="fonepay-category-code">
                <small *ngIf="fonePay.merchantCategoryCode?.errors && submitted" style="color: red;">
                  Merchant Category Code is required
                </small>
              </div>
              <div class="form-group">
                <label for="fonepay-currency">Secret Key<span>*</span></label>
                <input type="text" class="form-control" formControlName="secretKey" id="fonepay-secret-key">
                <small *ngIf="fonePay.secretKey?.errors && submitted" style="color: red;">
                  Merchant Category Code is required
                </small>
              </div>
              <div class="form-group text-right">
                <button type="submit" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="submit" class="btn btn-primary">Save changes</button>
              </div>
            </form>
          </div>
          <div class="tab-pane fade" id="nepalpay" role="tabpanel" aria-labelledby="nepalpay-tab">
            <form [formGroup]="nepalPayTerminalAddForm" (ngSubmit)="onSubmitTerminalAddForm()">
              <div class="form-group">
                <label for="nepalpay-terminal-id">Terminal ID<span style="color: red;">*</span></label>
                <input type="text" class="form-control" formControlName="terminalId" id="nepalpay-terminal-id">
                <small *ngIf="nepalPay.terminalId?.errors && submitted" style="color: red;">
                  Terminal IDis required
                </small>
              </div>
              <div class="form-group">
                <label for="nepalpay-merchant-id">Merchant ID<span style="color: red;">*</span></label>
                <input type="text" class="form-control" formControlName="merchantId" id="nepalpay-merchant-id">
                <small *ngIf="nepalPay.merchantId?.errors && submitted" style="color: red;">
                  Merchant ID is required
                </small>
              </div>
              <div class="form-group">
                <label for="nepalpay-currency">Currency<span style="color: red;">*</span></label>
                <input type="text" class="form-control" formControlName="currency" id="nepalpay-currency">
                <small *ngIf="nepalPay.currency?.errors && submitted" style="color: red;">
                  Currency is required
                </small>
              </div>

              <div class="form-group">
                <label for="nepalpay-currency">Merchant Category code<span style="color: red;">*</span></label>
                <input type="text" class="form-control" formControlName="merchantCategoryCode" id="nepalpay-currency">
                <small *ngIf="nepalPay.merchantCategoryCode?.errors && submitted" style="color: red;">
                  Merchant Category code is required
                </small>
              </div>

              <div class="form-group">
                <label for="nepalpay-currency">Acquirer Instrument<span style="color: red;">*</span></label>
                <input type="text" class="form-control" formControlName="acquirerInstrument" id="nepalpay-currency">
                <small *ngIf="nepalPay.acquirerInstrument?.errors && submitted" style="color: red;">
                  Acquirer Instrument is required
                </small>
              </div>

              <div class="form-group">
                <label for="nepalpay-currency">Merchant Name<span style="color: red;">*</span></label>
                <input type="text" class="form-control" formControlName="merchantName" id="nepalpay-currency">
                <small *ngIf="nepalPay.merchantName?.errors && submitted" style="color: red;">
                  Merchant Name is required
                </small>
              </div>

              <div class="form-group">
                <label for="nepalpay-currency">Merchant Address<span style="color: red;">*</span></label>
                <input type="text" class="form-control" formControlName="merchantAddress" id="nepalpay-currency">
                <small *ngIf="nepalPay.merchantAddress?.errors && submitted" style="color: red;">
                  Merchant Address is required
                </small>
              </div>

              <div class="form-group">
                <label for="nepalpay-currency">Merchant Pan<span style="color: red;">*</span></label>
                <input type="text" class="form-control" formControlName="merchantPanNumber" id="nepalpay-currency">
                <small *ngIf="nepalPay.merchantPanNumber?.errors&& submitted" style="color: red;">
                  Merchant PanNumber is required
                </small>
              </div>

              <div class="form-group">
                <label for="nepalpay-currency">Merchant Status<span style="color: red;">*</span></label>
                <input type="text" class="form-control" formControlName="merchantStatus" id="nepalpay-currency">
                <small *ngIf="nepalPay.merchantStatus?.errors && submitted" style="color: red;">
                  Merchant Status is required
                </small>
              </div>

              <div class="form-group text-right">
                <button type="submit" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button type="submit" class="btn btn-primary">Save changes</button>
              </div>

            </form>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>